import React from "react";

import { useGlobalContext } from "./context/globalContext";

const Hero = () => {
  const { handleShowModal } = useGlobalContext();
  return (
    <div id="home" className="section" style={{ padding: "0" }}>
      <div className="desktopview">
        <img
          onClick={handleShowModal}
          height="100%"
          width="100%"
          className="d-block micro-main-slider-img ls-is-cached lazyloaded"
          src="images/web-banner-01.jpeg"
          alt="Sheth Realty"
        />
      </div>
      <div className="mobileview">
        <img
          onClick={handleShowModal}
          height="100%"
          width="100%"
          className="d-block micro-main-slider-img ls-is-cached lazyloaded"
          src="images/mob-banner-01.jpeg"
          alt="Sheth Realty"
        />
      </div>
    </div>
  );
};

export default Hero;
